<template>
   <Toast />
   <Main v-if="layout == 'web'">
      <template v-slot:header>
         <Header />
      </template>

      <template v-slot:content>
         <router-view />
      </template>

      <template v-slot:footer>
         <Footer />
      </template>
   </Main>
   <Account v-else-if="layout == 'account' || (layout == 'admin' && (route.name != 'AdminLogin'))">
      <template v-slot:content>
         <router-view />
      </template>
   </Account>
   <div v-else>
      <router-view />
   </div>

   <!-- Premium Car Rental Mode Selection Modal (Temporarily commented off) -->
   <!--
   <transition name="fade">
      <div v-if="isCarRentalModalOpen" class="fixed inset-0 z-[99999] flex items-center justify-center p-4 bg-black/55 backdrop-blur-[3px]">
         <div class="relative w-full max-w-2xl bg-white rounded-3xl shadow-2xl border border-gray-100 overflow-hidden transform transition-all duration-300 flex flex-col p-8 gap-6">
            <button @click="isCarRentalModalOpen = false" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors">
               <i class="pi pi-times text-lg"></i>
            </button>

            <div class="text-center mt-2">
               <div class="inline-flex p-3 rounded-full bg-emerald-50 text-emerald-600 mb-2">
                  <i class="pi pi-car text-2xl"></i>
               </div>
               <h3 class="text-lg font-bold text-gray-900">Car Rental Options</h3>
               <p class="text-xs text-gray-500 font-semibold mt-1">Please select your preferred booking channel</p>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
               <div @click="handleOnlineBooking" class="group relative flex flex-row items-start p-5 bg-gradient-to-br from-emerald-600 to-teal-700 hover:from-emerald-500 hover:to-teal-600 rounded-2xl cursor-pointer text-white shadow-md hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200 text-left gap-4">
                  <div class="flex-shrink-0 flex items-center justify-center w-11 h-11 rounded-xl bg-white/20 group-hover:scale-110 transition-transform">
                     <i class="pi pi-globe text-lg text-white"></i>
                  </div>
                  <div class="flex flex-col">
                     <h4 class="text-sm font-extrabold tracking-wide uppercase">Online</h4>
                     <p class="text-[9px] text-emerald-200 font-extrabold mt-0.5 tracking-wider uppercase">(Credit Card Required)</p>
                     <div class="text-[10px] text-teal-100 font-semibold mt-2 leading-relaxed flex flex-col gap-0.5">
                        <span>Choose Your Car</span>
                        <span>Complete your Booking</span>
                        <span>Receive Immediate Confirmation</span>
                     </div>
                  </div>
               </div>

               <div @click="handleOfflineBooking" class="group relative flex flex-row items-start p-5 bg-gray-50 hover:bg-gray-100 border border-gray-200/80 rounded-2xl cursor-pointer shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 text-left text-gray-800 gap-4">
                  <div class="flex-shrink-0 flex items-center justify-center w-11 h-11 rounded-xl bg-gray-200 text-gray-600 group-hover:scale-110 transition-transform">
                     <i class="pi pi-file text-lg"></i>
                  </div>
                  <div class="flex flex-col">
                     <h4 class="text-sm font-extrabold tracking-wide uppercase text-gray-900">Offline</h4>
                     <div class="text-[10px] text-gray-500 font-semibold mt-2.5 leading-relaxed flex flex-col gap-0.5">
                        <span>Fill & Submit your Request</span>
                        <span>Our Team will Help You Complete your Booking</span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </transition>
   -->
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import Main from '@/layouts/Main.vue'
import Account from '@/layouts/Account.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { useRoute, useRouter } from 'vue-router'
import { isCarRentalModalOpen } from '@/utils/carRentalState'

const route = useRoute()
const router = useRouter()
const layout = computed(() => {
   return route.meta.layout
})

const handleOnlineBooking = () => {
   isCarRentalModalOpen.value = false
   window.open('https://www.booking.com/cars/index.en-gb.html?aid=2327698', '_blank')
}

const handleOfflineBooking = () => {
   isCarRentalModalOpen.value = false
   router.push({ name: 'CarRental', query: { mode: 'offline' } })
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
   transition: opacity 0.2s ease;
}
.fade-enter-from, .fade-leave-to {
   opacity: 0;
}
</style>
